/**
 * Sidebar Manager — Collapse, Mini, Mobile overlay
 */
export const SidebarManager = {
  init() {
    this.app = document.querySelector('.nw-app');
    if (!this.app) return;

    this.bindToggle();
    this.bindSubmenus();
    this.bindOverlay();
    this.restoreState();
  },

  bindToggle() {
    document.querySelectorAll('[data-nw-sidebar-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => this.toggle());
    });

    document.querySelectorAll('[data-nw-sidebar-mode]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const mode = btn.dataset.nwSidebarMode;
        this.setMode(mode);
      });
    });
  },

  toggle() {
    const nextOpen = this.app.classList.toggle('nw-app--sidebar-open');
    document.body.classList.toggle('nw-sidebar-open', nextOpen);
  },

  setMode(mode) {
    this.app.classList.remove('nw-app--sidebar-mini', 'nw-app--sidebar-compact', 'nw-app--sidebar-floating');
    if (mode && mode !== 'classic') {
      this.app.classList.add(`nw-app--sidebar-${mode}`);
    }
    localStorage.setItem('nw-sidebar-mode', mode || 'classic');
  },

  restoreState() {
    const mode = localStorage.getItem('nw-sidebar-mode');
    if (mode) this.setMode(mode);
  },

  bindSubmenus() {
    document.querySelectorAll('[data-nw-submenu-toggle]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        link.closest('.nw-sidebar__item')?.classList.toggle('nw-sidebar__item--open');
      });
    });
  },

  close() {
    this.app.classList.remove('nw-app--sidebar-open');
    document.body.classList.remove('nw-sidebar-open');
  },

  bindOverlay() {
    const overlay = document.querySelector('.nw-sidebar__overlay');
    overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('nw-sidebar-open')) {
        this.close();
      }
    });

    document.querySelectorAll('.nw-sidebar__link').forEach((link) => {
      link.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 991.98px)').matches) {
          this.close();
        }
      });
    });
  },
};
